import React, { Component } from 'react'

export default class NoInfo extends Component {
    render() {
        return (
            <div className="no-table-info container-centered">
                <div className="block centered">
                    <small> {this.props.text}</small>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/NoInfo/NoInfo.jsx